import { render, staticRenderFns } from "./PremiumContent.vue?vue&type=template&id=4fb1918d&scoped=true"
import script from "./PremiumContent.vue?vue&type=script&lang=js"
export * from "./PremiumContent.vue?vue&type=script&lang=js"
import style0 from "./PremiumContent.vue?vue&type=style&index=0&id=4fb1918d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb1918d",
  null
  
)

export default component.exports